<main class="bg-black text-white min-h-screen overflow-x-hidden">

  <!-- Hero -->
  <section class="relative min-h-[65vh] flex items-center pt-24 pb-14 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 right-0 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="absolute inset-0 opacity-[0.025]"
      style="background-image: linear-gradient(rgba(0,170,230,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(0,170,230,0.5) 1px, transparent 1px); background-size: 60px 60px;">
    </div>

    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="w-full">
        <a routerLink="/products/connectiq" class="back-nav" data-aos="fade-down">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
          Back to ConnectIQ
        </a>
        <h1 class="hero-col font-black mb-5" data-aos="fade-up" data-aos-delay="100">
          Industrial IoT <span class="text-varroc-accent">(IIoT)</span> for Smart Manufacturing
        </h1>
        <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 w-full !max-w-5xl" data-aos="fade-up"
          data-aos-delay="200">
          Transforming industrial operations with connected intelligence - digitize plant operations, monitor assets in
          real time, and drive data-driven decision-making across manufacturing and distribution environments, built on
          a robust ISA-95 architecture and aligned with OE/OP (Operational Excellence / Operational Performance)
          frameworks to ensure seamless integration between enterprise systems and shop-floor operations.
        </p>
        <div class="flex flex-wrap gap-4" data-aos="fade-up" data-aos-delay="300">
          <a routerLink="/contact-us"
            class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all industrial_iot_request_demo_button">
            Request Demo
          </a>
          <a routerLink="/resources"
            class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all industrial_iot_view_documentation_button">
            View Documentation
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- Sticky Nav -->
  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id"
          class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>

  <div class="max-w-7xl mx-auto px-6 py-20 space-y-28">

    <!-- Overview -->
    <section id="overview" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-center">
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Overview</span>
          <h2 class="text-4xl font-black mt-3 mb-5">Connected Intelligence for Industrial Operations</h2>
          <p class="text-varroc-text-gray leading-relaxed mb-4">Our IIoT platform enables organizations to digitize
            plant operations, monitor assets in real-time, and drive data-driven decision-making. By connecting
            machines, sensors, and systems, we provide end-to-end visibility and control across manufacturing and
            distribution environments.</p>
          <p class="text-varroc-text-gray leading-relaxed">From improving operational efficiency to enabling predictive
            maintenance, our IIoT solutions help industries move towards smarter, safer, and more efficient operations.
          </p>
        </div>
        <div class="grid grid-cols-2 gap-4" data-aos="fade-left">
          <div *ngFor="let h of highlights" class="feature-card text-center">
            <i class='bx icon-gradient text-3xl mb-3' [class]="h.icon"></i>
            <div class="text-white font-bold text-sm">{{ h.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Vision SDK -->
    <!-- <section id="visionsdk" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-center">
        <div class="grid grid-cols-2 gap-4" data-aos="fade-left">
          <div *ngFor="let v of visionsdk" class="feature-card text-center">
            <i class='bx icon-gradient text-3xl mb-3' [class]="v.icon"></i>
            <div class="text-white font-bold text-sm">{{ v.label }}</div>
          </div>
        </div>
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Vision SDK</span>

          <h2 class="text-4xl font-black mt-3 mb-5">AI-Powered Intelligent Vision</h2>
          <p class="text-varroc-text-gray leading-relaxed mb-4">Modern manufacturing requires high accuracy, speed, and
            consistency. However, traditional manual processes are often time-consuming, prone to errors, and difficult
            to scale, leading to reduced efficiency and productivity.
          </p>
          <p class="text-varroc-text-gray leading-relaxed">Our AI-powered Vision and Automation Platform enables
            organizations to overcome these challenges by automating processes with greater accuracy, speed, and
            scalability.
          </p>
        </div>

      </div>

      <div class="w-full flex items-center justify-center mt-10">
        <img src="../../../../../assets/images/websitev2/workflow-diagrams/vision-sdk-flow.png" alt="" class="w-[80%]">
      </div>
    </section> -->

    <!-- Vision SDK -->
    <section id="visionsdk" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-center">


        <!-- Content -->
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">
            Vision SDK
          </span>

          <h2 class="text-4xl font-black mt-3 mb-5">
            AI-Powered Vision Intelligence for Smart Manufacturing
          </h2>

          <p class="text-varroc-text-gray leading-relaxed mb-6">
            We deploy a scalable, edge-driven AI vision architecture designed for
            seamless integration into industrial environments. Our platform enables
            real-time inspection, automated defect detection, traceability, and
            intelligent decision-making directly on the production line.
          </p>

          <!-- Key Capabilities -->
          <div class="mb-6">
            <h3 class="text-white font-bold text-lg mb-3">
              Key Capabilities
            </h3>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
              <div class="flex items-center gap-2 text-varroc-text-gray">
                <i class="bx bx-check-circle text-varroc-accent"></i>
                Real-time image & video processing
              </div>

              <div class="flex items-center gap-2 text-varroc-text-gray">
                <i class="bx bx-check-circle text-varroc-accent"></i>
                Edge-based AI inference
              </div>

              <div class="flex items-center gap-2 text-varroc-text-gray">
                <i class="bx bx-check-circle text-varroc-accent"></i>
                Automated defect detection
              </div>

              <div class="flex items-center gap-2 text-varroc-text-gray">
                <i class="bx bx-check-circle text-varroc-accent"></i>
                Defect classification
              </div>

              <div class="flex items-center gap-2 text-varroc-text-gray">
                <i class="bx bx-check-circle text-varroc-accent"></i>
                Inspection & traceability
              </div>

              <div class="flex items-center gap-2 text-varroc-text-gray">
                <i class="bx bx-check-circle text-varroc-accent"></i>
                MES / PLC / ERP integration
              </div>
            </div>
          </div>

          <!-- Benefits -->
          <div>
            <h3 class="text-white font-bold text-lg mb-3">
              Business Benefits
            </h3>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
              <div class="flex items-center gap-2 text-varroc-text-gray">
                <i class="bx bx-bolt-circle text-varroc-accent"></i>
                Low-latency processing
              </div>

              <div class="flex items-center gap-2 text-varroc-text-gray">
                <i class="bx bx-bolt-circle text-varroc-accent"></i>
                Minimal production disruption
              </div>

              <div class="flex items-center gap-2 text-varroc-text-gray">
                <i class="bx bx-bolt-circle text-varroc-accent"></i>
                Multi-line scalability
              </div>

              <div class="flex items-center gap-2 text-varroc-text-gray">
                <i class="bx bx-bolt-circle text-varroc-accent"></i>
                Industry 4.0 ready
              </div>
            </div>
          </div>
        </div>

        <!-- Feature Cards -->
        <div class="grid grid-cols-2 gap-4" data-aos="fade-left">
          <div *ngFor="let v of visionsdk" class="feature-card text-center">
            <i class="bx icon-gradient text-3xl mb-3" [class]="v.icon"></i>
            <div class="text-white font-bold text-sm">{{ v.label }}</div>
          </div>
        </div>


      </div>

      <!-- Workflow Diagram -->
      <div class="w-full flex items-center justify-center mt-12">
        <img src="../../../../../assets/images/websitev2/workflow-diagrams/vision-sdk-flow.png"
          alt="Vision SDK Workflow" class="w-[85%] rounded-xl" />
      </div>
    </section>
    <div class="accent-divider"></div>

    <!-- Use Cases -->
    <!-- <section id="usecases" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Key Use Cases</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Industrial Applications</h2>
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div *ngFor="let uc of usecases; let i = index" class="feature-card" [attr.data-aos]="'fade-up'"
          [attr.data-aos-delay]="(i * 80).toString()">
          <div class="flex items-start gap-4 mb-4">
            <div class="w-12 h-12 bg-varroc-accent/15 rounded-xl flex items-center justify-center flex-shrink-0">
              <i class='bx icon-gradient text-2xl' [class]="uc.icon"></i>
            </div>
            <div>
              <h3 class="text-white font-bold text-lg mb-1">{{ uc.title }}</h3>
              <p class="text-varroc-text-gray text-sm leading-relaxed">{{ uc.desc }}</p>
            </div>
          </div>
          <ul class="space-y-2 pl-16">
            <li *ngFor="let pt of uc.points" class="flex items-start gap-2 text-varroc-text-gray text-sm">
              <i class='bx bx-check-circle icon-gradient text-base mt-0.5 flex-shrink-0'></i>
              {{ pt }}
            </li>
          </ul>
        </div>
      </div>
    </section> -->

    <section id="usecases" class="section-anchor">

      <div class="text-center mb-12">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">
          Key Use Cases
        </span>
        <h2 class="text-4xl font-black mt-2">
          Manufacturing Applications
        </h2>
      </div>

      <!-- AI Vision -->
      <div class="mb-12">
        <h3 class="text-white text-2xl font-bold mb-6">
          AI Vision Applications
        </h3>

        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div *ngFor="let uc of vision_sdk_usecases; let i = index" class="feature-card" [attr.data-aos]="'fade-up'"
            [attr.data-aos-delay]="(i * 80).toString()">
            <div class="flex items-start gap-4 mb-4">
              <div class="w-12 h-12 bg-varroc-accent/15 rounded-xl flex items-center justify-center flex-shrink-0">
                <i class='bx icon-gradient text-2xl' [class]="uc.icon"></i>
              </div>
              <div>
                <h3 class="text-white font-bold text-lg mb-1">{{ uc.title }}</h3>
                <p class="text-varroc-text-gray text-sm leading-relaxed">{{ uc.desc }}</p>
              </div>
            </div>
            <ul class="space-y-2 pl-16">
              <li *ngFor="let pt of uc.points" class="flex items-start gap-2 text-varroc-text-gray text-sm">
                <i class='bx bx-check-circle icon-gradient text-base mt-0.5 flex-shrink-0'></i>
                {{ pt }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Industrial IoT -->
      <div>
        <h3 class="text-white text-2xl font-bold mb-6">
          Industrial IoT Applications
        </h3>

        <div class="grid md:grid-cols-2 lg:grid-cols-2 gap-6">
          <div *ngFor="let uc of iiot_usecases; let i = index" class="feature-card" [attr.data-aos]="'fade-up'"
            [attr.data-aos-delay]="(i * 80).toString()">
            <div class="flex items-start gap-4 mb-4">
              <div class="w-12 h-12 bg-varroc-accent/15 rounded-xl flex items-center justify-center flex-shrink-0">
                <i class='bx icon-gradient text-2xl' [class]="uc.icon"></i>
              </div>
              <div>
                <h3 class="text-white font-bold text-lg mb-1">{{ uc.title }}</h3>
                <p class="text-varroc-text-gray text-sm leading-relaxed">{{ uc.desc }}</p>
              </div>
            </div>
            <ul class="space-y-2 pl-16">
              <li *ngFor="let pt of uc.points" class="flex items-start gap-2 text-varroc-text-gray text-sm">
                <i class='bx bx-check-circle icon-gradient text-base mt-0.5 flex-shrink-0'></i>
                {{ pt }}
              </li>
            </ul>
          </div>
        </div>
      </div>

    </section>
  </div>
</main>